import '.fd{height:2rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.bn{position:relative;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.db{position:sticky;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.go{z-index:8;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.c3{padding:1rem;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import { useCallback, useState } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.mobile'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { TextLink } from '@app/components/core/link/TextLink'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '6rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
}: TopNavBarProps) => {
  const [navigationMenuOpen, setNavigationMenuOpen] = useState(false)
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common
  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="fd"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }

    return userName ? (
      <div className="d cv"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="bn d k l ap"
          >
            <Avatar size="extra-small" labelSource={userName} image={avatar} />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="d cv"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <Button
          variant="primary"
          label={translations.signUp}
          size="small"
          onClick={() => showAuthModal('signUp')}
        />
      </div>
    )
  }, [isLoading, userName, avatar, showAuthModal, translations.signUp])

  return (
    <div className="z db cg go cn"
    >
      <nav className="cn z d c3 a0 l"
      >
        <Button
          variant="link"
          icon={faBars}
          onClick={() => setNavigationMenuOpen(true)}
        />
        <TextLink to={pages.home} noHover={true} isBold={false} hasIcon={false}>
          <Image
            src={fullLogo}
            alt="Crowdbuilding Logo"
            resizeWidth={123}
            style={{
              width: 123,
            }}
          />
        </TextLink>
        {renderAccountSection()}
      </nav>
      <MegaMenu
        onClose={() => setNavigationMenuOpen(false)}
        isAuthenticated={userName !== undefined}
        isOpen={navigationMenuOpen}
      />
    </div>
  )
}
